import { Record } from 'immutable';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import NameRecord from '../NameRecord';
import {
  baseKeys,
  FilterDefinitionTypeBaseFields,
  FilterDefinitionTypeMethods,
} from './FilterTypeDefinitionBase';

const keys: Fields = {
  ...baseKeys,
  min: 0,
  max: 0,
  steps: [],
  type: FilterDefinitionTypeConstants.RANGE,
};

export interface Fields extends FilterDefinitionTypeBaseFields {
  min: number;
  max: number;
  steps: number[];
  type: FilterDefinitionTypeConstants.RANGE;
}

export default class RangeFilterDefinitionTypeRecord
  extends Record<Fields>(keys)
  implements FilterDefinitionTypeMethods {
  constructor(values?) {
    super(values);

    const newValues: Partial<Fields> = {};

    if (values) {
      if (values.name) {
        newValues.name = new NameRecord(values.name);
      }
    }

    return this.merge(newValues);
  }

  getFilterKey(): string {
    return this.name.getName();
  }

  getName(): string {
    return this.name.getName();
  }

  getType() {
    return this.type;
  }

  getNameRecord(): NameRecord {
    return this.name;
  }

  getMin(): number {
    return this.min;
  }

  getMax(): number {
    return this.max;
  }

  getSteps(): number[] {
    return this.steps;
  }

  getTranslationKey(): string {
    return this.name.getTranslationKey() || '';
  }

  getFormattedFilterName(): string {
    return formatMessageWrapper(this.getTranslationKey());
  }
}
